module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chapname1",
    attrs: {
      "id": "sec2"
    }
  }, [_c('span', {
    staticClass: "box"
  }, [_vm._v("2.1")]), _vm._v(" REGIONAL REVIEW")]), _vm._v(" "), _c('h3', {
    staticClass: "chapname"
  }, [_vm._v("NORTH AND SOUTH AMERICA")]), _vm._v(" "), _c('p', {
    staticClass: "autor"
  }, [_vm._v("Author:"), _c('br'), _vm._v("Conrad Waters")]), _vm._v(" "), _c('h4', {
    staticClass: "sec1"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As always, naval developments in the Americas are ultimately dominated by financial and political considerations in the United States. The latest Bipartisan Budget Act (BBA), of November 2015, provided a further measure of relief from the caps on defence and other spending established by the 2011 Budget Control Act. By taking a two-year view, the legislation also ensured a welcome level of certainty over Department of Defense (DOD) spending for both FY2016 and FY2017. Total approved defence spending for FY2016 was a headline figure of US$580bn, a year-on-year increase of US$20bn and only a little under the US$585bn proposed under that year’s Presidential Budget Request. The likely settlement for FY2017 is tighter, with the deal agreed under the BBA limiting the proposed FY2017 DOD budget to a little-changed US$583bn."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "fr1"
    }
  }, [_vm._v("1")])]), _vm._v(" This is lower than previous DOD assumptions, resulting in cuts to planned procurement and the imposition of other efficiencies. The current administration has made it clear that further relaxation of financial controls will be needed after FY2017 if its defence strategy is to be achieved. Clearly, the outcome of the forthcoming Presidential Election will have a material impact on what actually transpires.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A key focus of the FY2017 budget was the perceived growth in the threat posed by China and Russia. They were explicitly named – alongside North Korea, Iran and global terrorism – as the five key challenges facing the US Military. As mentioned in the Introduction, this is resulting in priority being given to conventional deterrence against these two ‘most advanced adversaries’."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2",
      "id": "fr2"
    }
  }, [_vm._v("2")])]), _vm._v(" For the US Navy, this has involved an increased focus on high-intensity war-fighting rather than lower-intensity presence capabilities, with a particularly adverse impact on future Littoral Combat Ship (LCS) numbers. Planned acquisitions of the type will fall from fiftytwo to forty, protecting investment in areas such as naval aircraft and munitions that are perceived as being more critical in the current environment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The new plan halves LCS purchases over the next five years and starts to take effect immediately. The change is one of the factors behind a c. ten per cent fall in the previously envisaged FY2017 shipbuilding budget to US$14.7bn. Overall headline US Navy spending is budgeted at US$165bn, around US$4bn less than that enacted for the previous year."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3",
      "id": "fr3"
    }
  }, [_vm._v("3")])]), _vm._v(" This will also have a modest impact on the number of sailors. This will stabilise slightly below previously-planned levels at c. 323,000 active personnel. In spite of the decision to reduce LCS numbers, forward presence remains a key objective. Indeed, numbers of deployed ships are expected to increase over the next five years as completion of ships ordered in previous years reverses the recent decline in fleet size.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, to the north, Canada’s new Liberal government has embarked on what has been described as that country’s first comprehensive defence review since its 1994 Defence White Paper. The review is due to be concluded early in 2017. Many commentators believe that its findings will favour naval equipment procurement over other projects, particularly the Royal Canadian Air Force’s potential acquisition of F-35A Lightning II Joint Strike Fighters. It is likely that the recent focus on strengthening the military’s presence in the Canadian Arctic – primarily a naval/coast guard task – will also be maintained. However, it seems apparent that Canada is unlikely to follow the trend of rising defence spending seen elsewhere in the world, with the budget likely to be fixed at the current level of c. one per cent of GDP.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As such, there must be considerable uncertainty whether the navy’s future aspirations – most significantly its plan for up to fifteen new Canadian Surface Combatants to replace existing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Iroquois ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halifax ")]), _vm._v("class vessels – will be realised in their entirety. Certainly, recent reports that the likely construction cost of the new ships could more than double to CAD$30bn (US$23bn) is not encouraging."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4",
      "id": "fr4"
    }
  }, [_vm._v("4")])]), _vm._v(" The new administration remains committed to the National Shipbuilding Strategy that was first announced in 2010 but is already taking steps to ‘streamline’ the surface combatant programme. On 13 June 2016 it was announced that Canada would modify an existing warship design rather than continue with the previous approach of selecting a warship designer and a combat systems integrator to produce a bespoke design. Whether this will be sufficient to provide the required numbers remains a matter of conjecture.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(7).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Canada is currently in the middle of its first comprehensive defence review since 1994. The navy hopes the outcome")]), _vm._v(" will support its procurement objectives, notably the Canadian Surface Combatant that will replace the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Iroquois ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halifax ")]), _vm._v("classes. This image shows the modernised "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halifax ")]), _vm._v("class frigate "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Winnipe")]), _vm._v("g exercising with the Chilean replenishment tanker "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Almirante Montt ")]), _vm._v("in May 2016; past procurement delays mean that the Royal Canadian Navy does not currently have any replenishment vessels of its own. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Canadian Armed Forces)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tabhead",
    attrs: {
      "id": "tab2_1_1"
    }
  }, [_vm._v("Table 2.1.1: FLEET STRENGTHS IN THE AMERICAS – LARGER NAVIES (MID 2016)")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img3.jpg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "sec1"
  }, [_vm._v("MAJOR NORTH AMERICAN NAVIES – CANADA")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The future structure of Canada’s armed forces depends on the outcome of the current defence review. However, elements of the 2010 National Shipbuilding Strategy are already making progress. Notably, construction is now underway on the new, ice-capable Arctic offshore patrol ships of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harry DeWolf ")]), _vm._v("class. Initial steel cutting took place at Irving Shipbuilding’s Halifax Shipyard in June 2015 followed by the start of full construction on 1 September of that year. The new ships are intended to strengthen the enforcement of Canadian sovereignty in Arctic waters and are scheduled for delivery from 2018 onwards. Displacing around 6,500 tons – considerably more than the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halifax ")]), _vm._v("class frigates – the 103m-long ships are lightly armed with a BAE Systems 25mm Mk 38 gun to support constabulary operations. Of greater significance is their ability to carry a wide range of payloads, including shipping containers, underwater survey equipment or even a landing craft. There is also a special vehicle bay to house trucks, all-terrain vehicles and snowmobiles. A 20-ton capacity crane supports loading/unloading operations, whilst there are facilities to accommodate an embarked helicopter of up to CH-148 Cyclone size. A diesel-electric propulsion system provides a maximum speed in the order of 17 knots. It is hoped that the CAD$3.5bn (USS3.5bn) budget allocated to the programme will allow the completion of six ships. However, some reports suggest funding might not stretch far enough to pay for the as-yet unnamed sixth vessel. Work has also started on new refuelling and support facilities at Nanisivik on Baffin Island to provide logistic facilities for the class.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, preparations are underway for commencement of work on the first of two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Queenston ")]), _vm._v("class joint support ships. These are to be built by Seaspan’s Vancouver Shipyards on the west coast to a design based on the German Type 702 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Berlin ")]), _vm._v("class. Considerable delays in finalising the estimated CAD$2.6bn (US$2bn) programme – it was originally announced as long ago as 2004 – have meant that the Royal Canadian Navy’s existing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Protecteur ")]), _vm._v("class replenishment oilers have already been retired. Agreements with Chile and Spain for temporary access to their own vessels has eased some of the strain. However, a more comprehensive solution has been found under Project Resolve. This will involve a consortium headed by Quebec’s Chantier Davie yard converting the German-built container ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Asterix ")]), _vm._v("to act as an interim auxiliary oiler replenishment ship from 2017 until the second of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Queenston ")]), _vm._v("class vessels is delivered in 2021. The agreement involves the consortium funding both the capital cost of acquisition/conversion and ongoing crewing/operating charges in return for payments of c. CAD$700m (US$550m) over the life of a planned five-year deal."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5",
      "id": "fr5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although the use of a modified foreign design is expected to speed delivery of the Canadian Surface Combatant programme by two years, it will not be until construction of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harry DeWolf ")]), _vm._v("class begins to wind down at Halifax that assembly of the new ships will commence."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6",
      "id": "fr6"
    }
  }, [_vm._v("6")])]), _vm._v(" In the meantime, surface fleet operations will remain in the hands of the existing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halifax ")]), _vm._v("class, which have been modernised under the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halifax ")]), _vm._v("Class Modernisation/Frigate Equipment Life Extension (HCM/FELEX) programme. In April 2016, an important project milestone was achieved with completion of work on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Regina")]), _vm._v(", the fifth and final frigate to undergo modernisation at Seaspan’s west-coast Victoria Shipyards. The upgrade of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Toronto")]), _vm._v(", the seventh and last vessel to be modernised at the east-coast Halifax Shipyard is expected to be finished during the summer of 2016, with the programme on schedule to be finalised in accordance with its expected timescale at the start of 2018. A number of the upgraded ships have already deployed operationally and on exercises. Most significantly, both "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Winnipeg ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fredericton ")]), _vm._v("have operated with Standing NATO Maritime Group Two as part of Operation ‘Reassurance’, the Canadian military’s support for NATO assurance measures following Russia’s intervention in Ukraine.")]), _vm._v(" "), _c('p', {
    staticClass: "tabhead",
    attrs: {
      "id": "tab2_1_2"
    }
  }, [_vm._v("Table 2.1.2: CANADIAN NAVY: PRINCIPAL UNITS AS AT MID 2016")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img4.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(8).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Two computer-generated images of the new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harry DeWolf ")]), _vm._v("class Arctic offshore patrol ships on which construction has now started at Irving Shipbuilding’s Halifax Shipyard. The lightlyarmed, ice-strengthened vessels are intended to perform presence and constabulary duties in Canada’s Arctic, a region of increased strategic importance. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Irving Shipbuilding Inc.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(9).jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The December 2014 announcement of the achievement of fully operational status for the fourstrong "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Victoria ")]), _vm._v("(former British "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Upholder")]), _vm._v(") class submarine flotilla has proved somewhat premature. The discovery of defective welds undertaken by a sub-contractor to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Victoria ")]), _vm._v("in-Service Support Contract (VISC) mean that the west-coast based submarines "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicoutimi ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Victoria ")]), _vm._v("herself will need significant rectification work lasting into 2017. With "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Corner Brook ")]), _vm._v("in planned maintenance, this leaves only the east-coast based "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Windsor ")]), _vm._v("fully available for tasking at the present time.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(10).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The decommissioned replenishment oiler "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Protecteur ")]), _vm._v("pictured departing the naval base at Esquimalt on 24 February 2016 on her final journey to the scrapyard. She suffered a major engine room fire in February 2014 and it was determined repair was uneconomic given her limited remaining service life. Canadian west-coast shipyards declined to bid for the scrapping contract and the ship had to be towed 7,600 miles to a yard in Nova Scotia for the work to be carried out. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Canadian Armed Forces)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(11).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Canada has ordered two new")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Queenston ")]), _vm._v("class ships to replace her retired replenishment vessels but construction has yet to start and it will be several years before they are ready. In the interim, the Project Resolve consortium has obtained a contract to convert the German-built container ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Asterix ")]), _vm._v("to provide an interim capability – this graphic shows the extent of the changes required. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Project Resolve)")])])]), _vm._v(" "), _c('h4', {
    staticClass: "sec1"
  }, [_vm._v("MAJOR NORTH AMERICAN NAVIES – UNITED STATES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As demonstrated by "), _c('a', {
    attrs: {
      "href": "#/xhtml/teil2#tab2_1_3"
    }
  }, [_vm._v("Table 2.1.3")]), _vm._v(", US Navy Battle Force size had stabilised at c.270–275 ships as of June 2016. The expectation is that fleet numbers will experience a sustained rise over the rest of the decade. This is due largely to previous orders for significant numbers of Littoral Combat Ships (LCS) and, also, the restart of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arleigh Burke ")]), _vm._v("(DDG-51) class destroyer production. The US Navy currently maintains a force structure requirement of 308 ships. This is likely to be achieved in total – but not in terms of all constituent ship categories – during FY2021. The longer-term prognosis is less positive, with plans indicating shortfalls of surface combatants and attack submarines during the 2030s due to curtailment of LCS/light frigate construction and the need to complete the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ohio ")]), _vm._v("Replacement class (formerly SSBN-X) strategic submarines."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7",
      "id": "fr7"
    }
  }, [_vm._v("7")])]), _vm._v(" It is also noteworthy that even this likely battle force inventory requires funding that the US Navy has historically committed to new warship construction. A further complication is that the 308-ship requirement is based on a force structure assessment last carried out in 2012 and that was subject to only an interim update in 2014. The assumptions behind the requirement are now being revisited in light of the changed strategic environment. Press reports suggest that both major surface combatant and attack submarine goals are likely to be revised upwards."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn8",
      "id": "fr8"
    }
  }, [_vm._v("8")])]), _vm._v(" Conversely, it seems that targeted numbers of minor surface combatants will move downwards given the lower LCS requirement.")]), _vm._v(" "), _c('p', {
    staticClass: "tabhead",
    attrs: {
      "id": "tab2_1_3"
    }
  }, [_vm._v("Table 2.1.3: US NAVY BATTLE-FORCE DEVELOPMENT (FY 2015 TO FY 2021)")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "source1"
  }, [_vm._v("Note")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Forward data is derived from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Report to Congress on the Annual Long-Range Plan for Construction of Naval Vessels – June 2014 ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Report to Congress on the Annual Long-Range Plan for Construction of Naval Vessels – March 2015")]), _vm._v(", including their appendices on planned ship decommissionings. The numbers shown for 30 Sep 2015 reflect delays to delivering "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zumwalt ")]), _vm._v("(DDG-1000); in addition, it seems unlikely a further four LCS will have been commissioned by then.")]), _vm._v(" "), _c('p', {
    staticClass: "topindent"
  }, [_vm._v("A major impact on future fleet size will inevitably be the size of the future shipbuilding programme. Although this has remained inadequate to support longer-term goals, the navy has been reasonably successful in increasing the numbers of ships acquired in recent years. The headline numbers in the latest FY2017–FY2022 procurement plan – highlighted in "), _c('a', {
    attrs: {
      "href": "#/xhtml/teil2#tab2_1_4"
    }
  }, [_vm._v("Table 2.1.4")]), _vm._v(" – are therefore somewhat disappointing. They show a ten-ship reduction (from forty-eight to thirty-eight vessels) when compared with the equivalent FY2016–FY2021 programme. Whilst part of this is a reflection of Congressional acceleration of an expeditionary mobile base and a fleet tug into FY2016, the main factor is a halving of proposed LCS/light frigate orders from fourteen to seven units. Also noteworthy is the halving of orders for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia ")]), _vm._v("(SSN-774) class submarines to just one boat in FY2021 as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ohio ")]), _vm._v("Replacement Submarine programme begins in earnest.")]), _vm._v(" "), _c('p', {
    staticClass: "tabhead",
    attrs: {
      "id": "tab2_1_4"
    }
  }, [_vm._v("Table 2.1.4: USN FY2017 FIVE YEAR SHIPBUILDING PLAN (FY2017–FY2021)")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "source1"
  }, [_vm._v("Notes:")]), _vm._v(" "), _c('p', {
    staticClass: "source"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Figures in brackets relate to previous FY2016 Budget Request and Shipbuilding Plan.")]), _vm._v(" "), _c('p', {
    staticClass: "source"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Figures relate to Ship Battle Forces – Other Ships are not included.")]), _vm._v(" "), _c('p', {
    staticClass: "source"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" LCS production is planned to transition to the upgraded FF in FY2019.")]), _vm._v(" "), _c('p', {
    staticClass: "source"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" The FY2016 MLP mobile landing platform ship will be built as an afloat forward staging base (AFSB) variant.")]), _vm._v(" "), _c('p', {
    staticClass: "source"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" The SSBN-X is now known as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ohio ")]), _vm._v("Replacement Submarine; the JHSV is now known as the Expeditionary Fast Transport (EPF) and the MLP AFSB is now the Expeditionary Mobile Base (ESB).")]), _vm._v(" "), _c('p', {
    staticClass: "source"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" The FY2016 shipbuilding programme increased due to Congressional addition of one JHSV, one MLP and one TATS.")]), _vm._v(" "), _c('p', {
    staticClass: "topindent"
  }, [_vm._v("The current composition of the US Navy’s principal battle force units is set out in "), _c('a', {
    attrs: {
      "href": "#/xhtml/teil2#tab2_1_5"
    }
  }, [_vm._v("Table 2.1.5")]), _vm._v(", whilst further details on major ship categories follow.")]), _vm._v(" "), _c('p', {
    staticClass: "topnoindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Aircraft Carriers: ")]), _vm._v("The lead "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gerald R. Ford ")]), _vm._v("(CVN-78) class carrier is currently expected to commence sea trials in July 2016 following further programme delays that appear to be related to the innovative advanced arresting gear (AAG) that is being fitted to the ship. Although delivery is planned for the end of September 2016, it appears that the AAG will not be cleared to support fixed-wing operations until later in the year, when sea-based trials with F/A-18E/F Super Hornets will commence. There have been reports that the US Navy might revert to an upgraded variant of its current Mk 7 Mod 3 system for the two follow-on ships in the class as a result of the cost of AAG more than doubling. This is not, however, a straightforward decision as AAG is better suited to handling a broader range of aircraft, including the next-generation lighter unmanned aerial vehicles."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn9",
      "id": "fr9"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "tabhead",
    attrs: {
      "id": "tab2_1_5"
    }
  }, [_vm._v("Table 2.1.5: UNITED STATES NAVY: PRINCIPAL UNITS AS AT MID 2016")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "source1"
  }, [_vm._v("Notes:")]), _vm._v(" "), _c('p', {
    staticClass: "source"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Plus mission-related crew.")]), _vm._v(" "), _c('p', {
    staticClass: "source"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" Third of class, SSN-23 is longer and heavier.")]), _vm._v(" "), _c('p', {
    staticClass: "source"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" LHD-8 has many differences.")]), _vm._v(" "), _c('p', {
    staticClass: "source"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" Includes four LSD-49 HARPERS FERRY variants.")]), _vm._v(" "), _c('p', {
    staticClass: "topindent"
  }, [_vm._v("Other new systems installed in CVN-78, including its EMALS electro-magnetic catapults and dual band radar, appear to be faring well. EMALS, particularly, is proving more reliable than predicted. The new carrier is expected to embark on a protracted series of trials, training and work-up after delivery, culminating in shock trials in 2019. As such, it is unlikely to be before the end of the decade that she commences operational deployment. Meanwhile, work on the second member of the class – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John F. Kennedy ")]), _vm._v("(CVN-79) – is around twenty per cent complete following a formal keel-laying ceremony in August 2015. The first advanced procurement funding for the next ship, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enterprise ")]), _vm._v("(CVN-80) was authorised in the FY2016 budget prior to a request for formal approval in FY2018.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(12).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The new US Navy aircraft carrier "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gerald R. Ford ")]), _vm._v("(CVN-78) is now close to completion and is scheduled to commence sea trials in July 2016. This picture shows her being turned in the James River, Virginia on 11 June 2016 as part of pre-trial preparations. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(US Navy)")])])]), _vm._v(" "), _c('p', {
    staticClass: "topnoindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Surface Combatants: ")]), _vm._v("The near-four year hiatus in deliveries of major surface combatants ended in May 2016 with the transfer of the first "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zumwalt ")]), _vm._v("(DDG-1000) class destroyer to navy custody at the Bath Iron Works (BIW) yard in Maine. Her sister, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Michael Monsoor ")]), _vm._v("(DDG-1001), was christened on 18 June 2016. She is expected to be delivered before the end of 2017, although this may be subject to delay. There were a number of reports towards the end of 2015 that consideration was being given to cancelling the third ship, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lyndon B. Johnson ")]), _vm._v("(DDG-1002), on cost grounds."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10",
      "id": "fr10"
    }
  }, [_vm._v("10")])]), _vm._v(" However, perhaps because construction is well-advanced, the proposal now appears to be off the agenda. Further detail on the broader "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zumwalt ")]), _vm._v("class programme is contained in "), _c('span', {
    attrs: {
      "href": "#/xhtml/teil11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3.3")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(13).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The new Flight IIA "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arleigh Burke ")]), _vm._v("class destroyer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ralph Johnson ")]), _vm._v("(DDG-114) seen being floated out by HII’s Ingalls yard in December 2015. Ships from the restarted "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Burke ")]), _vm._v("class programme will start to be delivered over the next twelve months. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Huntington Ingalls Industries)")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zumwalt ")]), _vm._v("class truncated to just three ships, future US Navy surface-combatant construction is dominated by renewed fabrication of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arleigh Burke ")]), _vm._v("class destroyer variants. All of the additional twelve Flight IIA type ships envisaged under the restarted programme have now been ordered."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn11",
      "id": "fr11"
    }
  }, [_vm._v("11")])]), _vm._v(" Of these, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John Finn ")]), _vm._v("(DDG-113) is close to completion at Huntington Ingalls Industries’ (HII’s) Ingalls yard, which also launched "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ralph Johnson ")]), _vm._v("(DDG-114) on 12 December 2015. Construction is being shared with Bath Iron Works, which floated out "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rafael Peralta ")]), _vm._v("(DDG-115) the previous November. BIW is also being given responsibility for the first, modified Flight III variant. This incorporates Raytheon’s new modular AN/SPY-6 air and missiledefence radar (AMDR), as well as increased electrical generation capacity and an upgraded electrical grid. Further Flight III vessels will follow at a rate of two p.a. over the FY2017–FY2022 planning period.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(14).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An unusual view of the new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Independence ")]), _vm._v("variant LCS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Omaha ")]), _vm._v("(LCS-12) being transferred on a barge down the Mobile River to a floating-out dock on 19 November 2015. The water jets that form a key part of her propulsion system are clearly visible. Overall numbers of US Navy ships are set to rise over the next few years, with the delivery of a significant number of LCS a key factor behind this growth. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Austal USA)")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other main constituent of the surface fleet are the remaining twenty-two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ticonderoga ")]), _vm._v("(CG-47) class cruisers, which first introduced the Aegis system into operational service in 1982. The class have better command and control facilities than the smaller destroyers and one is typically assigned to each carrier group to co-ordinate the group’s air defence. The oldest eleven of these cruisers have already been upgraded to the latest Aegis standard. The US Navy now wants to undertake a phased modernisation of the remaining ships, using them to replace the older ships on a one-for-one basis as they fall due for retirement from FY2020 onwards. This would involve putting some of the unmodernised ships into temporary reserve to preserve their hull lives until upgrade commenced. There has been significant Congressional resistance to the plan, largely due to concerns that the ships put into reserve would never be reactivated. A compromise deal has limited the number of ships that can enter the modernisation programme at any one time. However, the navy is attempting to revisit the issue in the FY2017 budget. It argues that its original proposal would be more cost-effective and better ensure maintenance of an adequate fleet of command ships until a new generation of surface combatants enters service in the 2030s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Turning to smaller surface combatants, the decommissioning of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Simpson ")]), _vm._v("(FFG-56) at Mayport in Florida on 29 September 2015 marked the end of US Navy service for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oliver Hazard Perry ")]), _vm._v("(FFG-7) class frigates that first joined the fleet in 1977. Deliveries of both variants of the new LCS that serve as their effective replacements are starting to ramp up. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Milwaukee ")]), _vm._v("(LCS-5) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jackson ")]), _vm._v("(LCS-6) both commissioned towards the end of 2015 and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Montgomery ")]), _vm._v("(LCS-8) was delivered on 23 June 2016. Orders for the type now extend to thirteen of each variant. Under a previous programme restructuring announced in 2014, production was to shift to an upgraded, multi-mission light frigate configuration with effect from LCS-33 in FY2019. This would have given a total of thirty-two of the basic design and twenty of the frigates. However, the subsequent December 2015 decision to truncate the programme and slow construction means that the switch to the revised design will now seemingly take effect from the twenty-ninth ship. This produces a revised total of twenty-eight LCS and twelve frigates. The intention is also to focus on either the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Freedom ")]), _vm._v("(LCS-1) or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Independence ")]), _vm._v("(LCS-2) hull form at that stage, with inevitable consequences for which one of current builders Marinette Marine and Austal USA loses out. Two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Freedom ")]), _vm._v("class ships – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fort Worth ")]), _vm._v("(LCS-3) and the new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Milwaukee ")]), _vm._v("– have suffered high-profile engineering breakdowns in the past twelve months; these will not have helped that variant’s cause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The new frigates will have greater basic warfighting potential than the earlier ships but less capacity to accept the specialised mission modules that are a key part of the initial LCS concept. Moreover, it also seems that previous emphasis on the rapid interchangeability of these modules during deployments may be downgraded in favour of a ‘one ship, one mission’ approach for ships built to the basic design. Under this approach, these ships would be deployed with a specific anti-submarine, surface warfare or mine-countermeasures modules and be crewed accordingly."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn12",
      "id": "fr12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(15).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A view of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Freedom ")]), _vm._v("variant LCS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Milwaukee ")]), _vm._v("(LCS-5) transiting the St Lawrence Seaway on 30 November 2015, shortly after her commissioning at Milwaukee on 21 November. The ship subsequently suffered complete propulsion failure on 11 December after damage to a clutch and had to be towed to port. The damage has now been repaired. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Marc Piché)")])])]), _vm._v(" "), _c('p', {
    staticClass: "topnoindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Amphibious Shipping: ")]), _vm._v("The US Navy’s front-line amphibious force has been increased to thirty-one ships with the delivery of the tenth "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Antonio ")]), _vm._v("(LPD-17) amphibious transport dock, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John P. Murtha ")]), _vm._v("(LPD-26), on 13 May 2016. She will be formally commissioned in the autumn. The eleventh unit of the class, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Portland ")]), _vm._v("(LPD-27), was launched from HII’s Ingalls yard on 13 February 2016. The programme will conclude with a twelfth and final unit, to be named "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fort Lauderdale ")]), _vm._v("(LPD-28). The ship was formally approved in the FY2016 programme after being allocated unrequested funding by Congress in previous years."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn13",
      "id": "fr13"
    }
  }, [_vm._v("13")])]), _vm._v(" She will omit the composite masts of previous members of the class and is being seen as a bridge to the new LX(R) design that will be ordered from FY2020 onwards. Industry would like to bring this date forward to achieve the benefits of continuity of production; this will ultimately depend on the budgetary position and, doubtless, the continued strength of HII’s lobbying efforts. In the meantime, a third – as yet unnamed – member of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("America ")]), _vm._v("(LHA-6) class amphibious assault ships is included in the FY2017 budget request. Her design includes the addition of a well deck omitted from the first two ships.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The long-term amphibious fleet goal of thirtyfour ships still remains below that required to meet the stated objective of being able to transport the assault echelons of two Marine Expeditionary Brigades, let alone additional requirements that may arise for amphibious shipping. One way of squaring this particular circle has been investment in low-cost derivatives of civilian vessels to act as auxiliary amphibious ships. These include the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spearhead ")]), _vm._v("(EFP-1) class Expeditionary Fast Transports (formerly designated Joint High Speed Vessels), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Montford Point ")]), _vm._v("(ESD-1) class Expeditionary Transport Docks (the former Mobile Landing Platforms) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis B. Puller ")]), _vm._v("(ESB-3) class Expeditionary Mobile Bases (previously designated Afloat Forward Staging Bases)."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn14",
      "id": "fr14"
    }
  }, [_vm._v("14")])]), _vm._v(" The ships have been well-received in service and orders have been increased in consequence. However, they inevitably lack the survivability of true front-line warships.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The successful conduct of amphibious operations clearly requires effective transport from ship to shore over distances that are increasing due to the greater availability of precision weapons that can threaten major amphibious units. This is pushing an increased emphasis on air transportation – notably by the MV-22B Osprey and the CH-53 series of heavy lift helicopters – but surface connectors are still required. The most important current vessel in this category is the LCAC hovercraft, which are now approaching life expiry. The first examples of the replacement SSC ship-to-shore connectors are expected to be delivered for trials by Textron during 2017 before becoming operational in 2020. Preliminary design work is also underway on a surface connector replacement – SC(X)R – for the existing LCU 1600-class landing craft. Both types will be very similar in configuration to the types they replace but exploration of new concepts is also underway. The final piece of the jigsaw is the new AVC amphibious combat vehicle – a replacement for the venerable assault amphibious vehicles first introduced in 1972. BAE Systems and Science Applications International Corporation have been shortlisted to demonstrate competing off-the-shelf designs prior to the award of a contract for an interim vehicle. A more ambitious, bespoke design will be fielded at a later date.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(16).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The US Navy’s amphibious fleet increased to thirty-one ships, still somewhat short of the desired level, with the delivery of the tenth LPD-17 type amphibious transport dock, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John P. Murtha ")]), _vm._v("(LPD-26), in May 2016. This picture shows her on trials in March of that year. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Huntington Ingalls Industries)")])])]), _vm._v(" "), _c('p', {
    staticClass: "topnoindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Submarines: ")]), _vm._v("Construction of Block IV "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia ")]), _vm._v("class submarines continues at the rate of two p.a. under the latest multi-year procurement contract agreed for FY2014–FY2018. Production will then transition to the improved Block V variant. Most of these will carry the new Virginia Payload Module (VPM) that contains four additional large-diameter launch tubes for twenty-eight additional Tomahawk cruise missiles or similar weapons. This increase in weapons-carrying capacity will go some way to compensate for the withdrawal of the current converted "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ohio ")]), _vm._v("(SSGN-726) cruise missile submarines, which can each carry up to 154 missiles. However, as previously referenced, the need to commence construction of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ohio ")]), _vm._v("Replacement class strategic submarines in the early 2020s will result in a fall in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia ")]), _vm._v("class procurement. Given the rate of retirement of the remaining Cold War "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Los Angeles ")]), _vm._v("(SSN-668) class boats, this will lead to a growing shortfall against the required number of attack submarines from the second half of the decade onwards. The US Navy is looking at ways to reduce the gap. Potential solutions include modest increases to the service lives of existing submarines; deployments of longer duration; and the possibility of finding sufficient efficiencies to afford an additional, second "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia ")]), _vm._v("class boat in FY2021."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn15",
      "id": "fr15"
    }
  }, [_vm._v("15")])]), _vm._v(" A further complication is the discovery of defective welding in three of the class, removing them from the operational fleet until complicated repairs can be completed."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn16",
      "id": "fr16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(17).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The US Navy has been compensating for a shortfall in front-line amphibious vessels by innovative adaptations of commercial designs for second-line roles. This image shows "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lewis B. Puller ")]), _vm._v("(ESB-3), the first of three expeditionary mobile bases that are designed to support Special Forces, mine-countermeasures operations and various other command and intelligence-gathering functions. She is pictured off Norfolk, Virginia in October 2015. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Marc Piché)")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ohio ")]), _vm._v("Replacement programme, meanwhile, continues to move ahead. The navy announced in March 2016 that General Dynamics Electric Boat had, as expected, been selected as prime contractor for a project that could eventually amount to as much as US$100bn. In contrast to the arrangement for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia ")]), _vm._v("class, where construction is split between Electric Boat and HII’s Newport News facility, Electric Boat will undertake final assembly of all the strategic submarines. However, Newport News will be sub-contractor for around a fifth of the work and be given a larger share of future "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia ")]), _vm._v("class orders."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn17",
      "id": "fr17"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(18).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Los Angeles ")]), _vm._v("class submarine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Springfield ")]), _vm._v("(SSN-761) pictured on a port visit to the Royal Navy submarine base at Faslane, near Glasgow in April 2016. The Cold War-era "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Los Angeles ")]), _vm._v("class boats are set to be decommissioned faster than replacement "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia ")]), _vm._v("class submarines can be built, producing a gap in US Navy submarine capabilities. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(US Navy)")])])]), _vm._v(" "), _c('p', {
    staticClass: "topnoindent"
  }, [_vm._v("Turning to operations, the current emphasis on maintaining forward presence in key regional hotspots is inevitably having an impact on a fleet that is still some five years away from achieving its targeted size. Consequences of this have included greater length and unpredictability of deployments, a greater maintenance burden and an associated increased risk of gaps in ‘coverage’ emerging. A revised Optimized Fleet Response Plan (OFRP) was introduced in 2014 to try to bring greater stability to carrier strike group deployments for the benefit both of operational commands and the ships’ crews. Under this ‘supply-based’ model, strike groups will carry out a single seven-month deployment in a fixed 36-month cycle. This will allow sufficient time for maintenance and training, as well as including an extended ‘sustainment’ phase based at the group’s homeport to provide surge capacity. The jury remains out on the success of the new structure, although increases to maintenance budgets will certainly facilitate the fixed cycles working to schedule.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(19).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The US Navy "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nimitz ")]), _vm._v("class aircraft carriers "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John C. Stennis ")]), _vm._v("(CVN-74) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ronald Reagan ")]), _vm._v("(CVN-76) pictured operating together in the Philippine Sea in June 2016 as part of a training exercise that was criticised in the Chinese press. The Optimized Fleet Response Plan (OFRP) introduced in 2014 is set to give greater predictability to US Navy aircraft carrier availability. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(US Navy)")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another possible consequence of forward presence is a greater risk of clashes with potential adversaries. This danger was vividly demonstrated by a high profile incident in April 2016 where Russian Su-24 ‘Fencer’ attack aircraft made repeated low level passes over the destroyer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Donald Cook ")]), _vm._v("(DDG-75) whilst the US Navy was conducting exercises with Polish forces in the Baltic. There have been similar incidents involving US Navy reconnaissance aircraft and Chinese jets over the South China Sea, a region where American surface naval forces have also been stepping up their presence. A major deployment to the Philippine Sea in June 2016 saw two aircraft carriers – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John C. Stenni")]), _vm._v("s (CVN-74) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ronald Reagan ")]), _vm._v("(CVN-76) – operating together in a training exercise that drew strident criticism from the Chinese press. Potentially the most dangerous flashpoint, however, remains the Persian Gulf. Here two US Navy CB-90 riverine command boats and their ten-strong crew were briefly detained by Iran’s Islamic Revolutionary Guard after a navigational error caused them to stray into Iranian waters. The recent agreement of an accord on Iran’s nuclear programme probably spurred a swift resolution to a situation that could have had serious consequences.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The US Coast Guard continues to take delivery of ‘Legend’ class national security cutters and smaller ‘Sentinel’ class fast response cutters in replacement for legacy "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hamilton ")]), _vm._v("(WHEC-715) and ‘Island’ class types. Five ‘Legend’ class cutters are now in service following the commissioning of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("James ")]), _vm._v("(WMSL-754) in August 2015. Congress funded an unplanned ninth member of the class in FY2016 and there is also some Congressional pressure for a tenth ship. Thirty-eight fast response cutters have been approved to date out of a planned total of fifty-eight. All will be built by Bollinger Shipyards of Louisiana following a May 2016 following conclusion of a tender process for the final twenty-six. The result of competitive bids for the design of an intermediate offshore patrol cutter class – which is eventually planned to total twenty-five vessels – is expected to be announced before the end of 2016.")]), _vm._v(" "), _c('h4', {
    staticClass: "sec1"
  }, [_vm._v("OTHER NORTH AND CENTRAL AMERICAN NAVIES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To the south of the United States, "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Mexico ")]), _vm._v("continues to prioritise constabulary missions for its naval forces, which have played a significant and largely effective role in the fight against organised crime. The Mexican Naval Infantry Force has both sustained and inflicted casualties in actions against the powerful drug cartels, playing a major role in the recapture of the notorious drugs baron Joaquin ‘El Chapo’ Guzman at the start of 2016. The emphasis on policing and maritime security tasks is reflected in procurement. This is dominated by patrol and logistic support vessels. Prominent amongst the former are the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tenochtitlan ")]), _vm._v("class inshore patrol vessels, built in the naval ASTIMAR 1 shipyard at Tampico to the Dutch Damen Stan Patrol 4207 design. A contract for a further three vessels in January 2016 takes total orders to ten of the class out of a planned total of up to twenty units. Good progress is also being made with renewed construction of the much larger "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oaxaca ")]), _vm._v("class offshore patrol vessels. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chiapas")]), _vm._v(", the first of the new batch – and fifth member of the overall class – was launched on 13 November 2015. Work has also started on a sixth ship, to be named "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hidalgo")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The elderly – and often somewhat decrepit – state of the handful of former US Navy vessels that form the small fleet of front-line surface escorts is however leading to plans for replacement of these ships. It seems that the potential transfer of retired FFG-7 class frigates from the United States has been rejected in favour of domestic construction of a new light frigate design. A variant of the Damen Sigma design would seem a likely front-runner given the track record of successful co-operation with the Dutch company. However, the French ‘Gowind’ type may also be considered. It appears that a total of up to six ships is ultimately envisaged to replace existing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bronstein ")]), _vm._v("(FF-1037) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Knox ")]), _vm._v("(FF-1052) class frigates on a like-for-like basis. It is hoped the first ship will be in service around 2020.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Elsewhere in the region, the recapitalisation of the Royal "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Bahamas ")]), _vm._v("Defence Force under the US$230m ‘Sandy Bottom’ project is now close to completion. Two Damen Stan Patrol 3007 vessels and a Stan Lander 5612 landing craft were commissioned in March 2016. Four Stan Patrol 4207 patrol ships had been delivered earlier and the nine-ship programme will be completed with the arrival of two further Stan Patrol 3007 types before the end of 2016. The programme also includes the refit of two older boats and a major renewal of harbour infrastructure. All of this will be completed in the next twelve months, after which attention may turn to improving aerial surveillance capabilities."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn18",
      "id": "fr18"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(20).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Mexican Navy’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oaxaca ")]), _vm._v("class offshore patrol vessel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Independencia ")]), _vm._v("seen in 2012. The tug gives some idea of the diminutive nature of these ships. Four were delivered between 2003 and 2010 and another two, with different armament and other variations, are currently under construction. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(US Navy)")])])]), _vm._v(" "), _c('h4', {
    staticClass: "sec1"
  }, [_vm._v("MAJOR SOUTH AMERICAN NAVIES BRAZIL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Brazil is currently in the middle of a complicated economic and political crisis. 2016 is set to see the first multi-year recession since 1930–1 on the back of the sharp decline in commodity prices and a corruption scandal that has choked-off construction activity and indirectly resulted in the temporary suspension of President Dilma Rousseff whilst she faces impeachment on charges of financial irresponsibility and other irregularities."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn19",
      "id": "fr19"
    }
  }, [_vm._v("19")])]), _vm._v(" Underlying the political crisis are charges of corruption that implicate much of Brazil’s political class and many of its leading companies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prominent amongst the companies affected is the giant Odebrecht conglomerate. Its ICN subsidiary is contracted to complete the giant new submarine manufacturing complex and base facility at Itaguaí in conjunction with France’s DCNS under the PROSUB programme. Whilst the main elements of construction work are continuing, progress has been significantly slowed due to sharp budgetary reductions. Priority is being given to those parts of the complex required to support submarine assembly, which is also well underway. However, in June 2016, it became clear that assembly of the four ‘Scorpène’ type submarines being delivered under the project has been further delayed. The launch of the first boat, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Riachuelo")]), _vm._v(", is now scheduled for 2018. Delivery will follow in July 2020, some five years later than first planned. The three other boats will follow between 2021 and 2023. The future of the planned nuclear-powered submarine, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Álvaro Alberto")]), _vm._v(", the first in Latin America, seems subject to even more uncertainty and the likely start of construction remains uncertain."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn20",
      "id": "fr20"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "tabhead",
    attrs: {
      "id": "tab2_1_6"
    }
  }, [_vm._v("Table 2.1.6: BRAZILIAN NAVY: PRINCIPAL UNITS AS AT MID 2016")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If the PROSUB project is beset with difficulties, the challenges facing the surface fleet are even more substantial. Whilst the long-planned PROSUPER renewal programme to acquire new frigates and offshore patrol remains alive, there is little likelihood of funds being found for new surface construction in the near future. In the meantime, the operational fleet is shrinking as older vessels wear out. The frigate "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bosísio ")]), _vm._v("and corvette "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Frontin ")]), _vm._v("were both retired as earlier announced in September 2015, the latter subsequently being expended in a live-fire exercise in April 2016. The use of patrol vessels of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Amazonas ")]), _vm._v("class in place of the usual surface escorts to support the Brazilian Navy’s maritime contribution to the United Nations Interim Force in Lebanon (UNIFIL) is one indication of the degree of strain the surface fleet is under. However, construction of smaller patrol ships is also proving problematic. In early 2016, the navy decided to terminate a contract for the construction of followon "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Macaé ")]), _vm._v("class vessels with shipbuilder Estaleiro Ilha due to significant delays with the project. Assembly of some of the five ships that comprise this second batch – two were previously completed by another yard – is quite well advanced. The intention seems to be to get another company to complete the order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other ships being withdrawn over the past twelve months include the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aratu ")]), _vm._v("class minesweeper "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Abrolhos ")]), _vm._v("and the dock landing ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ceará")]), _vm._v(". The latter suffered a major propulsion failure in 2015 and has been replaced by the newly-acquired amphibious transport dock "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bahia")]), _vm._v(", formerly the French Navy’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sirocco. ")]), _vm._v("She was commissioned at Toulon in March 2016, arriving in Brazil the following month. Meanwhile, the proposed modernisation of the sole aircraft carrier, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("São Paulo")]), _vm._v(", may be put in jeopardy if reports of substantial cracks in her hull are confirmed."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn21",
      "id": "fr21"
    }
  }, [_vm._v("21")])]), _vm._v(" The 55-year-old ship – the former French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Foch ")]), _vm._v("– has been plagued by unreliability since her acquisition in 2000 and a major, four-year long refit has been planned to enable her to serve into the 2030s. Planned enhancements include a new propulsion system, reconstruction of catapults and lifts to handle heavier aircraft and a new combat system and sensors. Inevitably, this extensive package of work may not be cost-effective if damage is found to be substantial.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(21).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Brazilian Navy’s amphibious transport dock "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bahia")]), _vm._v(", formerly the French Navy’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sirocco")]), _vm._v(", pictured off Toulon in March 2016, shortly before her delivery voyage. Her acquisition represents a bright spot in an otherwise rather dismal year for the Brazilian Navy. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Brazilian Navy)")])])]), _vm._v(" "), _c('h4', {
    staticClass: "sec1"
  }, [_vm._v("OTHER SOUTH AMERICAN NAVIES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Elsewhere in Latin America, the change of presidency in "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Argentina ")]), _vm._v("is likely to see new President Mauricio Macri assume a lower profile towards the Falkland Island/Malvinas sovereignty dispute."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn22",
      "id": "fr22"
    }
  }, [_vm._v("22")])]), _vm._v(" There seems to be little prospect in any significant uplift in naval investment given the country’s economic challenges. Indeed, the re-establishment of an Argentine Air Force interceptor capability is likely to have first call on any available funds following retirement of the country’s Dassault Mirage fighters at the end of 2015. There have been various reports of planned purchases of second-hand ships – notably surplus A-69 corvettes from France and amphibious ships from the United States – as well as a re-start of the delayed offshore patrol vessel programme. It seems wise to take these reports with a pinch of salt until firm contracts are evidenced given the lack of past progress and the struggle even to keep a reasonable proportion of the current fleet operational. Previous reports that emerged in early 2015 relating to the potential acquisition of Chinese-built P18 corvettes have not yet been followed by any further developments. Any deal would now seem less likely given the Macri regime’s closer links with the United States. The sinking of a Chinese vessel that was supposedly illegally fishing in Argentine waters by the Argentine Coast Guard in March 2016 is also unlikely to have strengthened relations between the two countries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neighbouring "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Chile ")]), _vm._v("is largely focused on modernisation of existing naval assets. A major modernisation of the three British-built Type 23 frigates is likely to be contracted by the end of 2016. Domestic shipyard ASMAR has been undertaking the first refit of the ‘Scorpène’ type submarine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("O’Higgins ")]), _vm._v("and started work on the fourth "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Piloto Pardo ")]), _vm._v("Fassmer OPV-80 type patrol vessel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cabo Odger")]), _vm._v(", in May 2015. She will incorporate the improved armament and ice-strengthening applied to the third member of the class. Delivery is planned for 2017. Future construction plans include two further offshore patrol vessels and a new icebreaker.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Elsewhere in South America, "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Peru ")]), _vm._v("continues to make progress with its fleet renewal plan. This includes the local modernisation of its principal surface combatants and submarines, as well as indigenous construction of amphibious ships and patrol vessels. The life extension of its veteran "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lupo ")]), _vm._v("class frigates has taken a major step forward with the imminent return to the fleet of the first two vessels – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aguirre ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bolognesi ")]), _vm._v("– to complete their refits. Enhancements include an upgraded combat system, the installation of a multi-function Kronos radar and Exocet MM40 surface-to-surface missiles. The SIMA Shipyard in Callao is currently contracted to modernise four of the class. A further two vessels are expected to join the programme in due course. SIMA is also to undertake a refit of the navy’s four youngest Type 209 submarines – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Angamos")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Antofagasta")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pisagua ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chipana ")]), _vm._v("– with the help of ThyssenKrupp Marine Systems and Israel’s Elbit Systems. A significant upgrade programme is underway at the yard prior to the start of the project in 2017. Another SIMA project is for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paita")]), _vm._v(", the first of two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Makassar ")]), _vm._v("type amphibious transport docks, which should be launched around the end of 2016. SIMA has already delivered the sail training ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Unión")]), _vm._v(", which was commissioned on 27 January 2016.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to its salt-water commitments, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marina de Guerra del Perú ")]), _vm._v("also has important responsibilities policing the Peruvian Amazon. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jane’s Defence Weekly ")]), _vm._v("shed new light on this operation when they interviewed the head of the SIMA Shipyard in Iquitos in January 2016."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn23",
      "id": "fr23"
    }
  }, [_vm._v("23")])]), _vm._v(" The facility has the capability of constructing shallow-draft vessels of up to 1,500 tons displacement. It is currently in the course of delivering 350-ton "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Manuel Clavero ")]), _vm._v("class river gunboats, CB-90 derived "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rio Itaya ")]), _vm._v("class interceptors and an innovative class of humanitarian support vessels – the itinerant platforms for sustained social action (PIASS) – that provide a range of support services to isolated riverine communities. The navy has also previously taken delivery of a fleet of Griffon hovercraft to counter narcotics trafficking in the area.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Colombia ")]), _vm._v("has also been developing its indigenous naval construction capabilities. Shipbuilder COTECMAR is currently completing a third Fassmerdesigned OPV-80 patrol vessel and a series of 6,000-ton landing craft. At least one landing craft is also to be built for Honduras. The second OPV-80 type vessel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("7 de Augusto")]), _vm._v(", carried out a successful deployment to the Indian Ocean in the second half of 2015, operating with European Union and NATO forces on anti-piracy duties. The end of the fifty-year war with the revolutionary guerrilla movement FARC, heralded by the signature of a peace agreement in Havana, Cuba on 23 June 2016, may result in greater future involvement in international stabilisation missions of this kind. In the meantime, the fleet’s underwater capabilities have been strengthened by the long-awaited arrival of the two former German Navy Type 206 submarines acquired in August 2012. They have now completed lengthy refits – including modifications for warm-water operation – at ThyssenKrupp Marine Systems’ HDW yard in Kiel and were commissioned at the end of 2015."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn24",
      "id": "fr24"
    }
  }, [_vm._v("24")])]), _vm._v(" Meanwhile, "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Uruguay ")]), _vm._v("is also reportedly considering purchases of OPV-80 type vessels, although secondhand alternatives are also being considered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The economic crisis in "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Venezuela ")]), _vm._v("continues to impact both modernisation plans and operational availability. For example, repairs to the POVZEE class offshore patrol vessel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Warao")]), _vm._v(", heavily damaged in a grounding incident in 2013, appear to have ground to a halt for lack of funds. Her sister "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Guaiqueri ")]), _vm._v("may also need repairs after an explosion in March 2016 that left one crew member dead and several others badly injured.")]), _vm._v(" "), _c('p', {
    staticClass: "ref1"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "ref2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr1",
      "id": "fn1"
    }
  }, [_vm._v("1")]), _vm._v(".")]), _vm._v(" These figures are simplifications. The US$580bn authorised for FY2016 comprised a base budget of US$522bn and an additional US$58bn for overseas contingency operations (OCO) – essentially the additional cost of fighting wars such as those against the ‘Islamic State’. The comparable requests for FY2017 are US$524bn and US$59bn respectively. There has been considerable debate as to whether the OCO ‘slush fund’ has been partly used to compensate for inadequacies in the core budget as overseas operations have wound down. For further discussion, see Janine Davidson and Emerson Brooking’s ‘How the Overseas Contingency Operations Fund Works – and Why Congress Wants to Make it Bigger’ published on the Council on Foreign Relations website on 16 June 2015. The report’s co-author, Janine Davidson, assumed the position of Under Secretary of the US Navy in March 2016.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr2",
      "id": "fn2"
    }
  }, [_vm._v("2")]), _vm._v(".")]), _vm._v(" See further the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fiscal Year 2017 Budget Request Briefing ")]), _vm._v("(Washington DC: Office of the Under Secretary of Defense (Comptroller)/CFO, 2016). Full budget briefing materials can be found at: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://comptroller.defense.gov/BudgetMaterials.aspx",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("http://comptroller.defense.gov/Budget Materials.aspx")])])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr3",
      "id": "fn3"
    }
  }, [_vm._v("3")]), _vm._v(".")]), _vm._v(" The figures approved for FY2016 comprised US$159.3bn in base funding and US$9.4bn for OCO. The respective figures proposed for FY2017 are US$155.4bn and US$9.5bn, resulting in an overall decline of 2.3 per cent.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr4",
      "id": "fn4"
    }
  }, [_vm._v("4")]), _vm._v(".")]), _vm._v(" The potential increase in the cost of the Canadian Surface Combatant programme was revealed in James Cudmore’s ‘Cost to build navy’s new warships more than doubles to $30bn’, in a CBC News report of 1 December 2015. The report stated that the cost analysis was carried out independently by international consultancy A. T. Kearney. It suggested that total programme expenses could rise to C$42bn (compared with an original budget of C$26.2bn) when provision of ammunition, infrastructure and support services was taken into account. A copy can currently be found at: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.cbc.ca/news/politics/nspsnaval-ship-procurement-costs-1.3345435",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.cbc.ca/news/politics/nspsnaval-ship-procurement-costs-1.3345435")])])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr5",
      "id": "fn5"
    }
  }, [_vm._v("5")]), _vm._v(".")]), _vm._v(" This story has also been covered by CBC News’ James Cudmore in ‘Davie Shipyard’s $700m deal for navy supply ship retrofit to go ahead’. The story is currently available at: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.cbc.ca/news/politics/davie-shipyard-s-700m-deal-for-navy-supply-ship-retrofit-to-go-ahead-1.3344037",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.cbc.ca/news/politics/davie-shipyard-s-700m-deal-for-navy-supply-ship-retrofit-to-go-ahead-1.3344037")])])]), _vm._v(". It indicates that CAD$490m of this relates to the supply of the ship and its services – including a core crew. The balance encompasses fuel, port services and other marine costs. The navy will provide a small number of personnel to support refuelling and other naval activities.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr6",
      "id": "fn6"
    }
  }, [_vm._v("6")]), _vm._v(".")]), _vm._v(" Under the Canadian National Shipbuilding Strategy, Irving’s Halifax Shipyard has been allocated the construction of war-fighting vessels. Seaspan’s Vancouver Shipyards has been given responsibility for naval auxiliaries and other major government-owned ships.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr7",
      "id": "fn7"
    }
  }, [_vm._v("7")]), _vm._v(".")]), _vm._v(" Much of the information contained in this paragraph is based on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Report to Congress on the Annual Long-Range Plan for Construction of Naval Vessels for FY2017 ")]), _vm._v("(Washington DC: US Navy, 2016). Ronald O’Rourke’s periodically updated "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Navy Force Structure and Shipbuilding Plans: Background and Issues for Congress RL32665 ")]), _vm._v("(Washington DC: Congressional Research Service) and available on the FAS website "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.fas.org/sgp/crs/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.fas.org/sgp/crs/")])])]), _vm._v(" provides a good explanation of the various trends and issues arising from these annual reports.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr8",
      "id": "fn8"
    }
  }, [_vm._v("8")]), _vm._v(".")]), _vm._v(" For further detail, see Megan Eckstein’s ‘Navy Revising Force Structure Assessment In Light Of Increased Attack Sub, Other Ship Needs’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("USNI News – ")]), _vm._v("29 February 2016 (Annapolis MD: US Naval Institute, 2016). A copy can currently be found by searching "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.news.usni.org/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.news.usni.org/")])])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr9",
      "id": "fn9"
    }
  }, [_vm._v("9")]), _vm._v(".")]), _vm._v(" The teething troubles and cost overruns associated with AAG have been covered in a series of reports by Megan Eckstein and Sam LaGrone in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("USNI News")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ibid")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr10",
      "id": "fn10"
    }
  }, [_vm._v("10")]), _vm._v(".")]), _vm._v(" Amongst a number of journalists reporting on this issue was Tom Capaccio in ‘General Dynamics Destroyer Reviewed by U.S. for Cancellation’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bloomberg ")]), _vm._v("– 14 September 2015 (New York: Bloomberg LP, 2015).")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr11",
      "id": "fn11"
    }
  }, [_vm._v("11")]), _vm._v(".")]), _vm._v(" It was previously envisaged that eleven additional Flight IIA destroyers would be ordered. Construction would then shift to the Flight III design with effect from DDG-124, the second ship planned in the FY2016 programme. However, Congress authorised part-funding for an additional, third destroyer in the FY2016 budget. The opportunity has therefore been taken to squeeze another Flight II ship into planned construction. As such, it will be the third FY2016 ship, the future DDG-125, that will be the lead Flight III variant. Interestingly, however, the part funded-ship does not appear in the official shipbuilding plan. The allocation of this additional ship to BIW reflects a 2002 agreement re-assigning DDG-51 and LPD-17 amphibious transport dock construction between BIW and what is now HHI. As Congress had recently increased construction of LPD-17 type ships – built exclusively by HHI – by one, BIW was effectively ‘owed’ an additional destroyer.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr12",
      "id": "fn12"
    }
  }, [_vm._v("12")]), _vm._v(".")]), _vm._v(" Ronald O’Rourke’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Navy Littoral Combat Ship (LCS)/Frigate Program: Background and Issues for Congress RL33741 ")]), _vm._v("(Washington DC: Congressional Research Service), also available on the FAS website, is probably the best source of information available on the LCS programme’s convoluted history. The prospect of the interchangeable mission module approach being overturned is discussed more fully by David Larter in ‘Navy weighs radical changes to littoral combat ship crews, module’ in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Navy Times ")]), _vm._v("– 14 June 2016 (Springfield VA: Sightline Media Group, 2016).")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr13",
      "id": "fn13"
    }
  }, [_vm._v("13")]), _vm._v(".")]), _vm._v(" The detailed development of the class was covered by Scott Truver in ‘The US Navy’s LPD-17 Class: Snake Bit No More!’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seaforth World Naval Review 2016 ")]), _vm._v("(Barnsley: Seaforth Publishing, 2015), pp.104–23.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr14",
      "id": "fn14"
    }
  }, [_vm._v("14")]), _vm._v(".")]), _vm._v(" The new designations – agreed by Secretary of the Navy Ray Mabus in conjunction with the then Chief of Navy Operations Jonathan Greenert in September 2015 – introduces a new root designator – E for expeditionary support – to US Navy classifications. See Chris Cavas’ ‘A New Class of Ship – ‘Expeditionary Support’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Navy Times ")]), _vm._v("– 4 September 2015 (Springfield VA: Sightline Media Group, 2015). Analysis of the ships covered by the new designations has also been provided by Scott Truver in previous editions of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("World Naval Review")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr15",
      "id": "fn15"
    }
  }, [_vm._v("15")]), _vm._v(".")]), _vm._v(" Full detail on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Virginia ")]), _vm._v("class programme can be found in another of Ronald O’Rourke’s reports, viz. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Navy Virginia (SSN-774) Class Attack Submarine Procurement: Background and Issues for Congress RL32418 ")]), _vm._v("(Washington DC: Congressional Research Service).")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr16",
      "id": "fn16"
    }
  }, [_vm._v("16")]), _vm._v(".")]), _vm._v(" This story was covered extensively by David Larter in an article entitled ‘Secret weld: How shoddy parts disabled a $2.7 billion submarine’, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Navy Times ")]), _vm._v("– 28 March 2016 (Springfield VA: Sightline Media Group, 2016).")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr17",
      "id": "fn17"
    }
  }, [_vm._v("17")]), _vm._v(".")]), _vm._v(" For further detail, see Sydney J. Freedberg Jnr.’s ‘Ohio Replacement Plan is Good News for Electric Boat’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Breaking Defence ")]), _vm._v("– 29 March 2016 (New York: Breaking Media Inc., 2016).")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr18",
      "id": "fn18"
    }
  }, [_vm._v("18")]), _vm._v(".")]), _vm._v(" Progress with the upgrade programme was covered in greater detail by Alejandro Sanchez in ‘Bahamas’ Sandy Bottom project upgrades defence capabilities’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jane’s")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Defence Weekly ")]), _vm._v("– 1 June 2016 (Coulsdon: IHS Jane’s, 2016), p.13.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr19",
      "id": "fn19"
    }
  }, [_vm._v("19")]), _vm._v(".")]), _vm._v(" Brazil’s financial and political woes are far beyond the scope of this annual. For readers requiring more background, a good starting point is Peggy McInerny’s ‘What’s behind Brazil’s political and economic crises?’ posted to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("UCLA ")]), _vm._v("Newsroom on 16 May 2016 and currently available at: newsroom.ucla.edu/stories/what-sbehind-brazil-s-economic-and-political-crises.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr20",
      "id": "fn20"
    }
  }, [_vm._v("20")]), _vm._v(".")]), _vm._v(" The Portuguese language Poder Naval website at "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.naval.com.br/blog/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.naval.com.br/blog/")])])]), _vm._v(" remains an excellent source of information on current Brazilian Navy developments.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr21",
      "id": "fn21"
    }
  }, [_vm._v("21")]), _vm._v(".")]), _vm._v(" See Victor Barreira, ‘“Cracks found” in Brazil’s aircraft carrier’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jane’s Defence Weekly ")]), _vm._v("– 11 November 2015 (Coulsdon: IHS Jane’s, 2015), p.10.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr22",
      "id": "fn22"
    }
  }, [_vm._v("22")]), _vm._v(".")]), _vm._v(" The Spanish-language websites "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://infodefensa.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("infodefensa.com")])])]), _vm._v(" and "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://defensa.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("defensa.com")])])]), _vm._v(" have been useful sources of information for this section.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr23",
      "id": "fn23"
    }
  }, [_vm._v("23")]), _vm._v(".")]), _vm._v(" See further Guy Toremans’ interview with Captain Luis Diaz Ramirez in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jane’s Defence Weekly ")]), _vm._v("– 3 February 2016 (Coulsdon: IHS Jane’s, 2015), p.34.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fr24",
      "id": "fn24"
    }
  }, [_vm._v("24")]), _vm._v(".")]), _vm._v(" Further details were provided in Eric Wertheim’s ‘Combat Fleets’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Proceedings ")]), _vm._v("– vol. 142/4, April 2016 (Annapolis MD: US Naval Institute, 2016), p.92.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43e3402a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/teil2.vue
// module id = 75
// module chunks = 0